class global.ResourceBase
  collectionSuccess: (callback) ->
    (response) =>
      collection = for resource_attributes in response.body[@constructor.PLURAL_RESOURCE_NAME]
        new @constructor.MODEL(resource_attributes)

      result = {}
      result[@constructor.PLURAL_RESOURCE_NAME] = collection
      result['meta'] = response.body.meta if response.body.meta
      callback(result, response)

  collectionFailure: (callback) ->
    (response) ->
      callback(response) if callback
  memberCopy: (callback)->
    (response) =>

      return unless callback
      group = []
      result = {}
      attributes = response.body[@constructor.PLURAL_RESOURCE_NAME]

      if attributes.length > 1
        for i in attributes
          model = new @constructor.MODEL i
          group.push(model)

      else
        model = new @constructor.MODEL attributes[0]
        group.push(model)
      callback(group, response)
      
  memberSuccess: (callback) ->
    (response) =>

      return unless callback
      attributes = response.body[@constructor.SINGULAR_RESOURCE_NAME]

      
      model = new @constructor.MODEL attributes

      result = {}
      result[@constructor.SINGULAR_RESOURCE_NAME] = model
      callback(result, response)
    
  memberProperty: (callback) ->
    (response) =>
      return unless callback
      group = []
      result = response.body[@constructor.PLURAL_RESOURCE_NAME]
      if result != undefined
        for i in result
          model = new @constructor.MODEL i
          group.push(model)
      else
        group= []
      callback(group, response)
  
  getParamsId: (params) ->
    if params instanceof(FormData) then params.get('id') else params.id

  save: (success, failure, params = {}) ->
    if @getParamsId params
      @update success, failure, params
    else
      @create success, failure, params



// WEBPACK FOOTER //
// ./src/resources/base.coffee